import classNames from 'classnames'
import type {CommonProps} from '@/@types/common'
import {NavLink} from 'react-router-dom'
import {useAppSelector} from '@/store'

interface LogoProps extends CommonProps {
    type?: 'full' | 'streamline'
    mode?: 'light' | 'dark' | 'auto'
    imgClass?: string
    logoWidth?: number | string
}

const LOGO_SRC_PATH = '/assets/img/logo/'

const Logo = (props: LogoProps) => {
    const {
        type = 'full',
        mode = 'auto',
        className,
        imgClass,
        style,
        logoWidth = 'auto',
        height = 80,
        link = '/'
    } = props

    const themeMode = useAppSelector((state) => state.theme.mode)
    const logoMode = mode == "auto" ? themeMode : mode;

    return (
        <NavLink to={link}
                 className={classNames('logo', className)}
                 style={{
                     ...style,
                     ...{width: logoWidth}
                 }}
        >
            <img
                className={`/*h-full*/ !w-auto !mx-auto mt-0 mb-1 ${type == 'full' ? `` : ``} ${imgClass}`}
                src={`${LOGO_SRC_PATH}logo-${logoMode}-${type}.png`}
                alt={`logo`}
                style={{height}}
            />
        </NavLink>
    )
}

export default Logo
